import { format } from "date-fns";

export const convIsoToDateObj = (isoString) => {
  var dateArray = isoString.split(/[^0-9]/);
  return new Date(
    dateArray[0],
    dateArray[1] - 1,
    dateArray[2],
    dateArray[3],
    dateArray[4],
    dateArray[5]
  );
};

// Converts any native date time object to its direct isostring without adding an offset as the .toISOString function adds an offset.

export const convDateObjToISO = (dateTimeObject) => {
  var tzoffset = dateTimeObject.getTimezoneOffset() * 60000; //offset in milliseconds
  var ISOTime = new Date(dateTimeObject - tzoffset).toISOString().slice(0, -1);
  return ISOTime;
};

export const readableStartEnd = (start, end) => {
  if (!start || !end) {
    return "";
  }
  var startTime = start.toString().split(/[^0-9]/);
  var endTime = end.split(/[^0-9]/);
  var startObj = new Date(
    startTime[0],
    startTime[1] - 1,
    startTime[2],
    startTime[3],
    startTime[4],
    startTime[5]
  );
  var endObj = new Date(
    endTime[0],
    endTime[1] - 1,
    endTime[2],
    endTime[3],
    endTime[4],
    endTime[5]
  );

  if (format(startObj, "MMMM do") === format(endObj, "MMMM do")) {
    startObj.setHours(startObj.getHours());
    endObj.setHours(endObj.getHours());
    return (
      format(startObj, "MMM do, yyy h:mma") + " - " + format(endObj, "h:mma")
    );
  }
  startObj.setHours(startObj.getHours());
  endObj.setHours(endObj.getHours());
  return (
    format(startObj, "MMM do, yyy h:mma") +
    " - " +
    format(endObj, "MMM do, yyy h:mma")
  );
};

export const readableTime = (ISOString) => {
  if (!ISOString) return "";
  let dateObj = convIsoToDateObj(ISOString);
  return format(dateObj, "h:mma");
};

export const readableDate = (ISOString) => {
  if (!ISOString) return "";
  let dateObj = convIsoToDateObj(ISOString);
  return format(dateObj, "MMMM do");
};

export const readableDateTime = (ISOString) => {
  if (!ISOString) return "";
  let dateObj = convIsoToDateObj(ISOString);
  return format(dateObj, "MMMM do h:mma");
};
